import { render } from "./NewTicket.vue?vue&type=template&id=dfc53ea0&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"

import "./NewTicket.vue?vue&type=style&index=0&id=dfc53ea0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc53ea0"]])

export default __exports__